import type { NavigationChildItem, NavigationItem } from "../types/navigation";

/**
 * Pure active-state helpers for navigation items with children (PWA-2748
 * Section 3.1). Shared by Sidebar and MobileNav so both agree on which parent
 * and child are highlighted for a pathname.
 */

export const hasNavigationChildren = (item: NavigationItem): boolean =>
  Array.isArray(item.children) && item.children.length > 0;

/** Exact match on the child path, or the child path as a directory prefix. */
export const isNavigationChildActive = (child: NavigationChildItem, pathname: string): boolean =>
  pathname === child.path || pathname.startsWith(`${child.path}/`);

/** Exact match on the item path, or any child active. */
export const isNavigationItemActive = (item: NavigationItem, pathname: string): boolean =>
  pathname === item.path || (item.children ?? []).some(child => isNavigationChildActive(child, pathname));
